<template>
  <div class="samp">
    <div class="top">
      <Menu mode="horizontal" ref="slideMenu" :active-name="menu">
          <MenuItem :name="index" :to="p.url" v-for="(p,index) in navItems" :key="index">
            <Badge :count="p.count" type="error">
              <Icon :custom="p.icon" />
              {{p.menuName}}
            </Badge>
          </MenuItem>
      </Menu>
    </div>
    <div class="main">
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Samp',
  data () {
    return {
      navItems:[],
      menu:0
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.menu = this.navItems[0].sn-1;
      this.$refs.slideMenu.updateActiveName();
    })
    this.getCount();
    this.getItem();
  },
  methods:{
    getCount(){
    },
    getItem(){
      let data = [
        {icon:' iconfont icon-daizhifu',sn:1,menuName:'未采集',url:'/nosamp',count:0},
        {icon:' iconfont icon-caiyang',sn:2,menuName:'已采集',url:'/havesamp',count:0},
      ];
      this.navItems = data;
      // this.$emit('showNavItems',this.navItems);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
 
.samp{
  overflow: scroll;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/samp/Samp.vue